import makeStyles from '@mui/styles/makeStyles';

export const useFeedbackPanelStyles = makeStyles((theme) => ({
  divider: {
    width: '100%',
    margin: '1rem 0',
  },
  dividerWrapper: {
    position: 'relative',
    width: '100%',
  },
  buttonsContainer: {
    width: '100%',
    padding: '9px 20px',
    boxSizing: 'border-box',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '9px 20px',
    width: '100%',
    boxSizing: 'border-box',
  },
  modal: {
    backgroundColor: 'white',
    height: 'auto',
    width: '550px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  feedbackDetails: {
    width: '100%',
    boxSizing: 'border-box',
  },
  sectionTitle: {
    color: theme.palette.text.primary,
    marginBottom: '1rem',
    fontWeight: 500,
  },
  inputGroup: {
    marginBottom: '1rem',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
    },
    '& .MuiInputLabel-asterisk': {
      color: '#e43246',
    },
  },
}));
